import React from 'react'
import * as MicrophoneInput from './microphoneInput'
import { Dispatch } from './microphoneInput'
import { MicrophoneIcon } from '@heroicons/react/24/solid'
import { IconButton } from '~/components/IconButton'
import { Dropdown } from '~/components/Dropdown'
import { Button } from '~/components/Button'

export function AudioInputSelector({
  variant,
  align,
  state,
  dispatch,
}: {
  variant: 'icon-only' | 'labeled'
  align?: 'start' | 'end'
  state: MicrophoneInput.State
  dispatch: Dispatch
}) {
  const { selectedDeviceId, availableInputs } = state

  return (
    <Dropdown
      trigger={
        variant === 'icon-only' ? (
          <IconButton
            trigger={true}
            icon={<MicrophoneIcon />}
            screenReaderText="Microphone"
            tooltip="Select microphone"
          />
        ) : (
          <Button
            variant="outline"
            icon={<MicrophoneIcon className="icon-primary w-4 h-4" />}
            trigger={true}
            size="sm"
            tooltip="Select the microphone to capture"
          >
            {MicrophoneInput.getDeviceName(availableInputs, selectedDeviceId) || 'Default microphone'}
          </Button>
        )
      }
      align={align ?? 'start'}
      items={availableInputs.map((device) => ({
        icon: <MicrophoneIcon className="icon-primary w-6 h-6" />,
        text: device.label || `Microphone ${device.deviceId}`,
        checked: selectedDeviceId ? selectedDeviceId === device.deviceId : device === availableInputs[0],
        onClick: () => dispatch({ action: 'change-input', deviceId: device.deviceId }),
      }))}
    />
  )
}
